const {
  LEOPARD_ACCOUNTS,
  LEOPARD_ACCOUNTS_ERROR,
} = require('../actions/types');

const initialState = {
  data: null,
  loading: true,
  error: null,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case LEOPARD_ACCOUNTS:
      return {
        ...state,
        data: payload,
        loading: false,
      };

    case LEOPARD_ACCOUNTS_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
